import React, { useContext } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { UUIDContext } from "../UUIDContexted";
import CookiesPopup from '../components/CookiesPopup';

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const PBLData = useContext(UUIDContext);
  const merchant = "Pioneer";
  return (
    <>
      <Header merchantLogo={PBLData?.logoUrl} merchantName={merchant} uuid={PBLData?.linkId} />
      <main className="d-flex flex-grow-1">{children}</main>
      <CookiesPopup />
      <Footer />
    </>
  );
};

export default MainLayout;
